<template>
    <div class="main-section tabla-documentos">
        <DownloadBar
            v-if="!loading"
            class="mb-4"
            :download-doc="false"
            @on-send-email="onSendEmail"
            :total-items="total"
            :available-documents="availableDocuments"
            :show-succesfull-msg="showSuccesfullMsg"
            data-description="filas de movimientos bancarios"
            btn-send-email-desc="Enviar Libro Banco al correo"
        />
        <div class="container-table">
            <b-table
                :data="data"
                :loading="loading"
                paginated
                ref="table"
                backend-pagination
                :total="total"
                :per-page="16"
                @page-change="onPageChange"
                :current-page="currentPage"
                aria-next-label="Página Siguiente"
                aria-previous-label="Página Anterior"
                detailed
                :show-detail-icon="false"
                aria-page-label="Página"
                aria-current-label="Página Actual"
                backend-sorting
                @update-table="updateTable"
                class="bankMovementsTable"
            >
                <b-table-column v-slot="props">
                    <button
                        v-if="props.row.tax_documents.length > 0"
                        class="unstyleButton "
                        @click="toggle(props)"
                    >
                        <i
                            class="material-icons is-size-3 is-relative has-text-secondary"
                            style="top:3px;cursor:pointer"
                        >
                            {{
                                detailOpenList.includes(props.index)
                                    ? "keyboard_arrow_down"
                                    : "keyboard_arrow_right"
                            }}
                        </i>
                    </button>
                </b-table-column>
                <b-table-column
                    field="transaction_date"
                    label="Fecha"
                    numeric
                    centered
                    cellClass="document-number has-text-weight-bold is-size-6 is-family-monospace"
                    v-slot="props"
                >
                    {{ moment(props.row.accountant_date).format("DD/MM/YYYY") }}
                </b-table-column>
                <b-table-column
                    label="Mi banco"
                    numeric
                    centered
                    cellClass="is-size-6"
                    v-slot="props"
                >
                    {{ props.row.owner_account_name }}
                </b-table-column>
                <b-table-column
                    label="Descripción"
                    cellClass="is-size-6"
                    v-slot="props"
                >
                    <p class="has-text-weight-bold">
                        {{ props.row.description }}
                    </p>
                    <p>{{ props.row.comment }}</p>
                </b-table-column>
                <b-table-column
                    field="amount"
                    label="Cargo"
                    numeric
                    cellClass="document-amount has-text-weight-semibold has-text-right"
                    v-slot="props"
                >
                    <span
                        class="is-size-6 is-family-monospace"
                        v-if="props.row.amount < 0"
                    >
                        {{ parseToMoney(props.row.amount * -1) }}
                    </span>
                </b-table-column>
                <b-table-column
                    field="amount"
                    label="Abono"
                    numeric
                    cellClass="document-amount has-text-weight-semibold has-text-right"
                    v-slot="props"
                >
                    <span
                        class="is-size-6 is-family-monospace"
                        v-if="props.row.amount > 0"
                    >
                        {{ parseToMoney(props.row.amount) }}
                    </span>
                </b-table-column>
                <b-table-column
                    field="status"
                    label="Estado"
                    centered
                    cellClass="document-name has-text-weight-semibold"
                    v-slot="props"
                >
                    <b-button
                        size="is-small"
                        :type="reconcileStatus(props.row.reconcile_status).type"
                        outlined
                        @click="modalBankReconciliation(props.row)"
                        class="stateReconciliation"
                        :class="
                            reconcileStatus(props.row.reconcile_status).class ||
                                ''
                        "
                    >
                        <div
                            class="is-flex is-justify-content-space-between is-align-item-center"
                        >
                            <span>{{
                                reconcileStatus(props.row.reconcile_status).name
                            }}</span>
                            <i class="material-icons is-size-7">
                                {{
                                    reconcileStatus(props.row.reconcile_status)
                                        .icon
                                }}
                            </i>
                        </div>
                    </b-button>
                </b-table-column>
                <template #empty>
                    <div v-if="isDownloadMovements" class="has-text-centered">
                        <h3 class="has-text-weight-semibold">
                            Conexión bancaria exitosa
                        </h3>
                        <p>
                            Estamos cargando todos tus movimientos desde enero
                            del 2020, esto puede tardar un poco :)
                        </p>
                    </div>
                    <div v-else class="has-text-centered">
                        <p>No hay movimientos para mostrar</p>
                    </div>
                </template>
                <template #detail="props">
                    <ListBankMovementsDetail :data="props.row" />
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { sendEmail } from "@/api/exportDocuments";
import DownloadBar from "@/components/downloadBar/DownloadBar";
import BankReconciliation from "@/components/modals/BankReconciliation";
import { parseToMoney } from "@/utils/currency";
import { consoleHandlerError, notificate } from "@/utils/message";
import moment from "moment";
import { mapMutations, mapState } from "vuex";
import segmentAnalytics from "../../utils/segmentAnalytics";
import ListBankMovementsDetail from "./ListBankMovementsDetail";

export default {
    name: "ListBankMovements",
    data() {
        return {
            modalDefault: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
            showSuccesfullMsg: null,
            availableDocuments: [
                {
                    value: "allBanksMovementsReport",
                    name: "Reporte de Movimientos Bancarios",
                },
            ],
        };
    },
    props: ["data", "loading", "total", "currentPage"],
    components: {
        ListBankMovementsDetail,
        DownloadBar,
    },
    methods: {
        parseToMoney,
        ...mapMutations("financialEntity", [
            "SET_MODAL_DATA",
            "SET_DETAILS_OPEN_LIST",
        ]),
        moment(date) {
            return moment(date);
        },
        toggle(row) {
            let arr = this.detailOpenList;
            if (arr.includes(row.index)) {
                arr.splice(arr.indexOf(row.index), 1);
            } else {
                arr.push(row.index);
            }
            this.SET_DETAILS_OPEN_LIST(arr);
            this.$refs.table.toggleDetails(row.row);
        },
        onPageChange(page) {
            this.$emit("on-page-change", page);
        },
        updateTable() {
            this.$emit("update-table");
        },
        modalBankReconciliation(item) {
            this.SET_MODAL_DATA({ ...item });
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: BankReconciliation,
                width: 1200,
            });
        },
        reconcileStatus(val) {
            const status = val ? val.toLowerCase() : "";
            switch (status) {
                case "bank_reconciliation":
                    return {
                        name: "CONCILIADO",
                        class: "reconciliation",
                        type: "is-income",
                        icon: "check",
                    };
                case "bank_semi_reconciliation":
                    return {
                        name: "SEMI CONCILIADO",
                        type: "is-fellow",
                        icon: "sync_alt",
                    };
                default:
                    return {
                        name: "NO CONCILIADO",
                        type: "is-opposite",
                        icon: "sync_alt",
                    };
            }
        },
        onSendEmail(data) {
            new segmentAnalytics().trackDownloadDocument({
                section: "banks",
                name: data.name,
            });
            sendEmail(data)
                .then(({ data: result }) => {
                    this.showSuccesfullMsg = true;
                    // Transparencia: el backend dice qué bancos salieron; si
                    // alguno falló (partial) el detalle va como warning.
                    if (result && result.message) {
                        notificate(
                            result.message,
                            result.partial
                                ? "is-warning is-light"
                                : "is-success is-light"
                        );
                    }
                    setTimeout(() => {
                        this.showSuccesfullMsg = null;
                    }, 3000);
                })
                .catch((error) => {
                    // Fallo total (502 del backend): ningún correo salió.
                    this.showSuccesfullMsg = false;
                    consoleHandlerError({ error });
                });
        },
    },
    computed: {
        ...mapState("financialEntity", [
            "isDownloadMovements",
            "detailOpenList",
        ]),
        ...mapState("userAuth", ["user"]),
    },
};
</script>
